import React from 'react';
import styled from 'styled-components';
import { colorThemeGenerator, ButtonPrimary, Type } from '@spotify-internal/encore-creator-web';
import {
  azure,
  gray10,
  white,
  spacer16,
  spacer20,
  screenMdMin,
} from '@spotify-internal/encore-foundation';
import { pageConstraintStyles, PAGE_GUTTER } from './styles';
import { TextWithDesktopLineBreak } from '../Shared/TextWithDesktopLineBreak';

export function ClaimBanner() {
  return (
    <ClaimBannerContainer>
      <div style={{ flexGrow: 1, backgroundColor: white }} />
      <ClaimBannerContentWrapper>
        <ClaimBannerContent>
          <ClaimBannerHeader>Podcast already on Spotify?</ClaimBannerHeader>
          <Type as="p" variant={Type.body1}>
            Claim your podcast and get instant access to your current stats and audience data.
            <TextWithDesktopLineBreak variant={Type.body1}>
              Or you can add your show to Spotify in a few easy steps.
            </TextWithDesktopLineBreak>
          </Type>
          <ButtonPrimary
            href={`${window.location.origin}/submit`}
            theme={{
              ...colorThemeGenerator({
                primaryColor: azure,
                primaryColorText: white,
                primaryColorFocusText: white,
                primaryColorActiveText: white,
              }),
            }}
            style={{ marginTop: spacer20 }}
          >
            Claim Your Podcast
          </ButtonPrimary>
          <JaggedEdgeSvg width="32px" height="100%">
            <pattern
              id="landing-page-zig-zag"
              width="32px"
              height="64px"
              patternUnits="userSpaceOnUse"
              fill={white}
            >
              <polygon points="0,0 32,32 0,64" />
            </pattern>
            <rect width="100%" height="100%" fill="url(#landing-page-zig-zag)" />
          </JaggedEdgeSvg>
        </ClaimBannerContent>
      </ClaimBannerContentWrapper>
      <div style={{ flexGrow: 1 }} />
    </ClaimBannerContainer>
  );
}

const ClaimBannerContainer = styled.div`
  width: 100%;

  @media (min-width: ${screenMdMin}) {
    display: flex;
    position: absolute;
    transform: translateY(-50%);
    z-index: 1;
  }
`;

const ClaimBannerContentWrapper = styled.div`
  color: ${gray10};

  @media (min-width: ${screenMdMin}) {
    ${pageConstraintStyles}

    display: grid;
    grid-template-columns: 5fr 1fr;
    width: 100%;
  }
`;

const ClaimBannerContent = styled.div`
  background-color: white;
  padding: 42px ${spacer16};

  @media (min-width: ${screenMdMin}) {
    padding: 56px 0 56px ${PAGE_GUTTER};
    position: relative;
  }
`;

const ClaimBannerHeader = styled(Type).attrs({
  forwardedAs: 'h2',
  variant: Type.heading2,
})`
  font-size: 28px;
  line-height: 32px;
  padding-bottom: 28px;

  @media (min-width: ${screenMdMin}) {
    font-size: 48px;
    line-height: 1em;
  }
`;

const JaggedEdgeSvg = styled.svg`
  display: none;

  @media (min-width: ${screenMdMin}) {
    display: block;
    position: absolute;
    top: 0;
    right: -32px;
    transform: scale(1); /* fix 1px transparent gap that appears on certain browsers */
  }
`;
